import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/permanentmarker/ProductShowcase";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet";

const Permanentmarker = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
    <Helmet>
        <title>Permanent Marker - Pungent & Sticky with a Unique Aroma | BeyondBloom™</title>
        <meta
          name="description"
          content="Permanent Marker is a potent strain known for its pungent, sticky texture and a unique, lingering aroma that cannabis connoisseurs love."
        />
        <meta
          name="keywords"
          content="Permanent Marker strain, sticky cannabis, pungent aroma, cannabis flavors, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Permanent Marker - Pungent & Sticky with a Unique Aroma | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Permanent Marker is a potent strain known for its pungent, sticky texture and a unique, lingering aroma that cannabis connoisseurs love."
        />
        <meta property="og:image" content="/images/permanent-marker.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/permanent-marker" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Permanent Marker - Pungent & Sticky with a Unique Aroma | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Permanent Marker is a potent strain known for its pungent, sticky texture and a unique, lingering aroma that cannabis connoisseurs love."
        />
        <meta name="twitter:image" content="/images/permanent-marker.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Permanentmarker;
